module.exports = __webpack_public_path__ + "img/global-energy-co2-data.de323df.jpg";